import React, { RefObject } from 'react';

function moveFocusToNextFavoriteItem(
  sectionIndex: number,
  itemIndex: number,
  favoritesRefs: RefObject<HTMLDivElement>[][]
) {
  if (itemIndex < favoritesRefs[sectionIndex].length - 1) {
    // Move down within the current section
    favoritesRefs[sectionIndex][itemIndex + 1]?.current?.focus();
  } else if (sectionIndex < favoritesRefs.length - 1) {
    // Move to the first item of the next section
    favoritesRefs[sectionIndex + 1][0]?.current?.focus();
  } else {
    // Move to the first item of the first section
    favoritesRefs[0][0]?.current?.focus();
  }
}

export function moveFocusUponDeletion(
  sectionIndex: number,
  itemIndex: number,
  favoritesRefs: RefObject<HTMLDivElement>[][],
  anchorEl: HTMLElement | null
) {
  const flatRefs = favoritesRefs.flat().filter((ref) => ref);
  // If there are no favorite items or the only favorite item is the one being deleted, focus on the anchor element
  if (flatRefs.length === 0 || (flatRefs.length === 1 && flatRefs[0] === favoritesRefs[sectionIndex][itemIndex])) {
    anchorEl?.focus();
  } else {
    moveFocusToNextFavoriteItem(sectionIndex, itemIndex, favoritesRefs);
  }
}

export function handleFocusBetweenFavoriteItems(
  key: string,
  sectionIndex: number,
  itemIndex: number,
  favoritesRefs: RefObject<HTMLDivElement>[][]
) {
  if (key === 'ArrowUp') {
    if (itemIndex > 0) {
      // Move up within the current section
      favoritesRefs[sectionIndex][itemIndex - 1]?.current?.focus();
    } else if (sectionIndex > 0) {
      // Move to the last item of the previous section
      favoritesRefs[sectionIndex - 1][favoritesRefs[sectionIndex - 1].length - 1]?.current?.focus();
    } else {
      // Move to the last item of the last section
      const lastSectionIndex = favoritesRefs.length - 1;
      const lastItemIndex = favoritesRefs[lastSectionIndex].length - 1;
      favoritesRefs[lastSectionIndex][lastItemIndex]?.current?.focus();
    }
  } else if (key === 'ArrowDown') {
    moveFocusToNextFavoriteItem(sectionIndex, itemIndex, favoritesRefs);
  }
}

export const initializeFavoritesRefs = (favorites) => {
  return favorites?.map((favoriteSection) => favoriteSection?.items?.map(() => React.createRef<HTMLDivElement>()));
};
